import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_s435f7c5ne: FaireBrandEntity = {
  token: "b_s435f7c5ne",
  type: "brand",
  name: "Lord's Light Candle",
  avatarUrl:
    "https://cdn.faire.com/fastly/1d24bb67186a38250bbf933a6e59b681874772d5a149a473a29a8c2288bfbe8c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c199ee260956bf3fc5d9edf911ceb2b59d5ab2fd128464b187681748dd4d1b0a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1d24bb67186a38250bbf933a6e59b681874772d5a149a473a29a8c2288bfbe8c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c199ee260956bf3fc5d9edf911ceb2b59d5ab2fd128464b187681748dd4d1b0a.jpeg",
  location: "Colleyville, TX, USA",
  minimumOrderDollars: 144,
  rating: 5,
  reviewCount: 7,
  isTopShop: true,
  isInsider: true,
  description:
    "The Lord’s Light Candle Company was born when the founders felt God ignite their passion to transform a long-held creative dream into a mission-centered business. Rooted in Deuteronomy 6:5–9, each hand-poured candle carries a “Reveal” band that slowly illuminates a verse as it burns, serving as a beautiful reminder that God’s Word belongs in every part of our lives—while biblically inspired scents like calming lavender and fresh‑baked cookies build sensory connections to Scripture.\n\nMore than just ambiance, the brand is driven by a spiritual responsibility: to uplift hearts, share God’s love through an inspirational gift, and give back—donating part of their proceeds to Christian education.\n\nCrafted with premium soy‑coconut wax, dye‑ and phthalate‑free, and housed in recyclable vessels, these candles reflect respect for God’s creation and aim to let His light shine—one glow at a time.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:25.575Z",
    importedBy: "entity-db-cli",
  },
};
